<template>
    <div class="container">
        <div class="toolbar">
            <el-form :inline="true" size="small">
                <el-form-item label="状态">
                    <el-select v-model="search.status" placeholder="状态" @change="handleSearch">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                </el-form-item>
            </el-form>
            <el-button type="primary" size="small" @click="openCreate">新建功能特性</el-button>
        </div>

        <el-table v-loading="loading" border :data="list" size="small">
            <el-table-column prop="item_key" label="特性标识" min-width="180"></el-table-column>
            <el-table-column prop="item_name" label="特性名称" min-width="160"></el-table-column>
            <el-table-column label="状态" width="100">
                <template v-slot="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
                        {{ scope.row.status === 1 ? '启用' : '禁用' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="260">
                <template v-slot="scope">{{ scope.row.remark || '-' }}</template>
            </el-table-column>
            <el-table-column label="操作" width="170" fixed="right">
                <template v-slot="scope">
                    <el-button type="primary" size="mini" @click="openEdit(scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="deleteFeature(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination v-model:currentPage="search.page" :page-size="search.limit" :total="total"
            layout="total, prev, pager, next" @current-change="loadList"></el-pagination>

        <el-dialog :title="editingId ? '编辑功能特性' : '新建功能特性'" v-model="dialogVisible" width="520px"
            @closed="resetForm">
            <el-form ref="featureForm" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="特性标识" prop="item_key">
                    <el-input v-model.trim="form.item_key" placeholder="例如 cloud_storage"></el-input>
                </el-form-item>
                <el-form-item label="特性名称" prop="item_name">
                    <el-input v-model.trim="form.item_name" placeholder="例如 云端存储"></el-input>
                </el-form-item>
                <el-form-item v-if="editingId" label="状态" prop="status">
                    <el-radio-group v-model="form.status">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="form.remark" type="textarea" :rows="3"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" :loading="saving" @click="saveFeature">确定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import api from '../../../axios/pack'

const defaultForm = () => ({
    item_key: '',
    item_name: '',
    status: 1,
    remark: ''
})

export default {
    name: 'HuntingPackageFeatures',
    data() {
        return {
            search: {
                page: 1,
                limit: 20,
                status: -1
            },
            list: [],
            total: 0,
            loading: false,
            saving: false,
            dialogVisible: false,
            editingId: 0,
            form: defaultForm(),
            rules: {
                item_key: [{ required: true, message: '请输入特性标识', trigger: 'blur' }],
                item_name: [{ required: true, message: '请输入特性名称', trigger: 'blur' }],
                status: [{ required: true, message: '请选择状态', trigger: 'change' }]
            }
        }
    },
    methods: {
        handleSearch() {
            this.search.page = 1
            this.loadList()
        },
        loadList() {
            this.loading = true
            api.HuntingPackageFeatureDictList(this.search).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.data || []
                    this.total = res.data.data.page_info ? res.data.data.page_info.total : 0
                    return
                }
                this.$message.error('获取功能特性失败：' + res.data.msg)
            }).finally(() => {
                this.loading = false
            })
        },
        openCreate() {
            this.editingId = 0
            this.form = defaultForm()
            this.dialogVisible = true
        },
        openEdit(row) {
            this.editingId = row.id
            this.form = {
                item_key: row.item_key,
                item_name: row.item_name,
                status: row.status,
                remark: row.remark || ''
            }
            this.dialogVisible = true
        },
        resetForm() {
            this.editingId = 0
            this.form = defaultForm()
            if (this.$refs.featureForm) this.$refs.featureForm.clearValidate()
        },
        saveFeature() {
            this.$refs.featureForm.validate(valid => {
                if (!valid) return
                this.saving = true
                const request = this.editingId
                    ? api.HuntingPackageFeatureDictUpdate({ id: this.editingId, ...this.form })
                    : api.HuntingPackageFeatureDictCreate({
                        item_key: this.form.item_key,
                        item_name: this.form.item_name,
                        remark: this.form.remark
                    })
                request.then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(this.editingId ? '修改成功' : '创建成功')
                        this.dialogVisible = false
                        this.loadList()
                        return
                    }
                    this.$message.error((this.editingId ? '修改' : '创建') + '失败：' + res.data.msg)
                }).finally(() => {
                    this.saving = false
                })
            })
        },
        deleteFeature(row) {
            this.$confirm('确定删除功能特性“' + row.item_name + '”?', '提示', { type: 'warning' }).then(() => {
                api.HuntingPackageFeatureDictDelete({ id: row.id }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('删除成功')
                        if (this.list.length === 1 && this.search.page > 1) this.search.page -= 1
                        this.loadList()
                        return
                    }
                    this.$message.error('删除失败：' + res.data.msg)
                })
            }).catch(() => {})
        }
    },
    created() {
        this.loadList()
    }
}
</script>

<style scoped>
.toolbar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
</style>
